// TV2DKHEADER
(() => {
  const header = document.querySelector('.tc_header');
  const isAuthenticated = window?.dataLayer?.ssrAuthenticated;
  const badgeEnabled = false; // toggle red badge on loginbutton

  // HEADER VISIBILITY
  const headerScrollAnimation = () => {
    const headerHeight = header.offsetHeight;
    const initAnimationAfter = 500;
    const scrollTriggerDelta = 100;

    let scrolling;
    let ticking = false;
    let lastScroll = 0;

    const headerAnimate = () => {
      // scrolling down
      if (scrolling - scrollTriggerDelta > lastScroll) {
        if (headerHeight < scrolling) {
          header.classList.remove('tc_header--sticky-show');
        }

        if (headerHeight * 2 < scrolling) {
          header.classList.add('tc_header--sticky');
        }

        if (initAnimationAfter < scrolling) {
          // we need to make sure tc_header--sticky and the animate class
          // is not set in the same tick
          // if they are both added in the same tick, the animation transition will flash
          setTimeout(() => {
            header.classList.add('tc_header--sticky-animate');
          }, 0);
        }

        lastScroll = scrolling;

        // scrolling up
      } else if (
        scrolling + scrollTriggerDelta < lastScroll ||
        scrolling < headerHeight
      ) {
        if (!header.classList.contains('tc_header--sticky-animate')) {
          header.classList.remove('tc_header--sticky');
        }

        header.classList.add('tc_header--sticky-show');

        lastScroll = scrolling;
      }

      if (
        scrolling === 0 ||
        (header.getAttribute('data-variant') === 'feature' &&
          scrolling < headerHeight)
      ) {
        header.classList.remove('tc_header--sticky');
        header.classList.remove('tc_header--sticky-animate');
        header.classList.remove('tc_header--sticky-show');
      }

      ticking = false;
    };

    const headerRequestTick = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(headerAnimate);
      }
    };

    const headerOnScroll = () => {
      scrolling = window.scrollY;
      headerRequestTick();
    };

    // init watching for scroll
    window.addEventListener('scroll', headerOnScroll, false);
  };

  // DIALOGS (menu & login)
  const dialogs = () => {
    let clickCancel;
    let clickOutside;

    // get dialog button by id and action
    const getButton = (targetId, targetAction) => {
      return header.querySelector(
        `[popovertarget=${targetId}][popovertargetaction=${targetAction}]`,
      );
    };

    // Open a dialog
    const dialogOpen = (target, targetId) => {
      // handle scrollbar to eleminate page jump on dialog openings
      const root = document.documentElement;
      const scrollbarWidth = window.innerWidth - root.clientWidth;
      root.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);

      // open actual dialog modal
      target.showModal();

      const showButton = getButton(targetId, 'show');

      // Safari: timeout of '0' animates dialog properly in :(
      setTimeout(() => showButton.setAttribute('aria-expanded', 'true'), 0);

      // Set up dialog to close when clicking 'esc''
      clickCancel = (e) => {
        e.preventDefault();
        dialogClose(target, targetId);
        trackEvent(`tv2dk.header.${targetId}.close`);
      };
      target.addEventListener('cancel', clickCancel);

      // Set up dialog to close when clicking outside the modal
      clickOutside = (e) => {
        const dialog = document.getElementById(targetId);
        if (e.target === dialog) {
          dialogClose(target, targetId);
          trackEvent(`tv2dk.header.${targetId}.close`);
        }
      };
      target.addEventListener('click', clickOutside);

      // animate the accordions in both dialog menus
      animateAccordion(target);

      // if loginmenu dialog
      if (targetId === 'loginmenu') {
        handleBadge('open');
        themeSelector();
        regionSelector();
      }
    };

    // Close a dialog
    const dialogClose = (target, targetId) => {
      const showButton = getButton(targetId, 'show');
      showButton.setAttribute('aria-expanded', 'false');

      // remove handlers
      target.removeEventListener('cancel', clickCancel);
      target.removeEventListener('click', clickOutside);

      // Wait for CSS animation to end before closing dialog
      setTimeout(() => target.close(), 300);

      // if loginmenu dialog
      if (targetId === 'loginmenu') {
        handleBadge('close');
      }
    };

    // BUTTON CLICK EVENTHANDLER
    const buttonClickHandler = (e) => {
      const button = e.target.closest('.tc_button');
      const nativeDialogSupport = typeof HTMLDialogElement === 'function';

      if (button) {
        const targetId = button.getAttribute('popovertarget');
        const targetAction = button.getAttribute('popovertargetaction');
        const target = header.querySelector(`#${targetId}`);

        // a dialog action button
        if (target && targetId && targetAction && nativeDialogSupport) {
          e.preventDefault();

          if (target) {
            targetAction === 'show' && dialogOpen(target, targetId);
            targetAction === 'hide' && dialogClose(target, targetId);
          }
        }

        // login button
        if (button.classList.contains('tc_header__dialog__main__btns__login')) {
          e.preventDefault();
          window.tv2.auth0.login('login', window.location.href);
        }

        // signup button
        if (
          button.classList.contains('tc_header__dialog__main__btns__signup')
        ) {
          e.preventDefault();
          window.tv2.auth0.login('signup', window.location.href);
        }

        // logout button
        if (
          button.classList.contains('tc_header__dialog__main__btns__logout')
        ) {
          e.preventDefault();
          window.tv2.auth0.logout();
        }
      }
    };

    // ACCORDION ANIMATION
    const animateAccordion = (target) => {
      const wrapper = target.querySelector('.tc_header__dialog__main__nav');
      const detailsList = wrapper.querySelectorAll(
        'details:not(:has(summary[tabindex="-1"]))',
      );

      if (wrapper.dataset.processed !== 'js') {
        detailsList.forEach((details) => {
          const summary = details.querySelector('summary');
          const link = summary.querySelector('a');

          details.style.maxHeight = `${details.offsetHeight}px`;

          summary.addEventListener('click', (e) => {
            e.target === summary && e.preventDefault();
            const summaryHeight = summary.offsetHeight;
            const detailsContent = summary.nextElementSibling;

            if (e.target !== link) {
              if (details.hasAttribute('open')) {
                details.style.maxHeight = `${summaryHeight}px`;
                setTimeout(() => details.removeAttribute('open'), 300);
              } else {
                details.setAttribute('open', 'open');
                const detailsContentHeight = detailsContent.offsetHeight;
                const detailsHeight = `${
                  summaryHeight + detailsContentHeight
                }px`;
                details.style.maxHeight = detailsHeight;
              }
            }
          });
        });
        wrapper.setAttribute('data-processed', 'js');
      }
    };

    // THEME
    const themeWrapper = header.querySelector(
      '.tc_header__dialog__main__nav__item--theme',
    );
    const themeTag = document.querySelector('meta[name="color-scheme"]');
    const themeTagValue = themeTag && themeTag.getAttribute('content');
    const themeTagDefaultValue = themeTag && themeTag.getAttribute('data-default');

    if (isAuthenticated) {
      const themeCookieValue = window.tv2.utils.getCookie('tv2Theme');

      if (themeCookieValue) {
        // mark radio option selected based on theme set in cookie
        const themeSelected = themeWrapper.querySelector(
          `input[value="${themeCookieValue}"]`,
        );
        if (themeSelected) {
          themeSelected.checked = true;
        }

        // keep cookie and metatag in sync
        if (themeTagValue !== themeCookieValue) {
          themeTag.setAttribute('content', themeCookieValue);
        }
      } else {
        // force default setting in metatag if no cookie exists
        if (themeTagValue !== themeTagDefaultValue) {
          themeTag.setAttribute('content', themeTagDefaultValue);
        }
      }
    }

    // listen for theme selection by user
    const themeSelector = () => {
      if (isAuthenticated) {
        const themeSubtext = themeWrapper.querySelector(
          '.tc_header__dialog__main__nav__item--theme .tc_header__dialog__main__nav__item__subtext',
        );
        const themeInputs = themeWrapper.querySelectorAll(
          'input[name="theme"]',
        );
        for (const themeInput of themeInputs) {
          themeInput.addEventListener('change', (e) => {
            const themeValue = e.target.value;
            const themeLabel = themeWrapper.querySelector(
              `label[for="${e.target.id}"]`,
            ).textContent;
            themeSubtext.textContent = themeLabel;

            // set theme in metatag (CSR) and store theme selection in a cookie (SSR)
            if (themeValue !== themeTagDefaultValue) {
              themeTag.setAttribute('content', themeValue);
              window.tv2.utils.setCookie('tv2Theme', themeValue, '365 days');

              // or remove cookie if value matches the default
            } else {
              themeTag.setAttribute('content', themeTagDefaultValue);
              window.tv2.utils.setCookie('tv2Theme', '', -1);
            }

            // close the accordion
            const summary = themeWrapper.querySelector(
              'summary:not([tabindex="-1"])',
            );
            summary && summary.click();

            // track the event
            trackEvent(`tv2dk.theme.${e.target.value}`);
          });
        }
      }
    };

    // REGION
    const regionSelector = () => {
      const regionWrapper = header.querySelector(
        '.tc_header__dialog__main__nav__item--region',
      );
      const regionSubtext = regionWrapper.querySelector(
        '.tc_header__dialog__main__nav__item__subtext',
      );
      const regionDefaultValue =
        regionWrapper.querySelector('input[checked]').value;
      const regionInputs = regionWrapper.querySelectorAll(
        'input[name="region"]',
      );
      const regionCookieValue = window.tv2.utils.getCookie('tv2Region');

      // if the region is already set in a cookie, change the subtext
      if (regionCookieValue) {
        const regionLabel = regionWrapper.querySelector(
          `label[for="region-${regionCookieValue}"]`,
        ).textContent;
        regionSubtext.textContent = regionLabel;
      }

      // mark radio option selected based on region set in cookie
      const regionValue = regionCookieValue || regionDefaultValue;
      regionWrapper.querySelector(
        `input[value="${regionValue}"]`,
      ).checked = true;

      // listen for region selection by user
      for (const regionInput of regionInputs) {
        regionInput.addEventListener('change', (e) => {
          const regionValue = e.target.value;

          // change subtext to match selected region
          const regionLabel = regionWrapper.querySelector(
            `label[for="${e.target.id}"]`,
          ).textContent;
          regionSubtext.textContent = regionLabel;

          // change data attribute to alert regionalDeck about the change
          const form = regionWrapper.querySelector(
            '.tc_header__dialog__main__nav__item__region',
          );
          form.setAttribute('data-region', regionValue);

          // store new region selection in a cookie
          if (regionValue !== regionDefaultValue) {
            window.tv2.utils.setCookie('tv2Region', regionValue, '365 days');
            // or remove cookie if value matches the default
          } else {
            window.tv2.utils.setCookie('tv2Region', '', -1);
          }

          // close the accordion
          regionWrapper.querySelector('summary:not([tabindex="-1"])').click();

          // track the event
          trackEvent(`tv2dk.region.${e.target.value}`);
        });
      }
    };

    // init watching for menu button clicks
    document.body.addEventListener('click', buttonClickHandler, false);
  };

  // REEL REFERER
  const reelReferrer = () => {
    const referrerUrl = document.referrer && new URL(document.referrer);
    const referrerFromTv2Dk =
      referrerUrl && referrerUrl.hostname.indexOf('tv2.dk') > -1;

    // if the user came from tv2.dk give them a 'close button' instead of the burger menu
    if (referrerFromTv2Dk) {
      const button = document.querySelector(
        '.tc_header__global__buttons__close',
      );
      if (button && history.length > 1) {
        button.removeAttribute('hidden');
        button.addEventListener('click', () => history.back());
      }
    }
  };

  // TRACKING
  const trackEvent = (event) => {
    try {
      window.tv2.analyticsUtils.trackEvent(event);
    } catch (_) {
      console.warn('unable to track event', { event });
    }
  };

  // BADGE
  const loginButton = header?.querySelector(
    '.tc_header__global__buttons__login',
  );
  if (badgeEnabled && loginButton) {
    const badgeCookie = window.tv2.utils.getCookie('tv2Badge');
    !badgeCookie && loginButton.setAttribute('data-badge', 'true');
  }

  const handleBadge = (action) => {
    if (badgeEnabled && loginButton.hasAttribute('data-badge')) {
      if (action === 'open') {
        // User has seen badge message so hide on future visits
        window.tv2.utils.setCookie('tv2Badge', 'hide', '14 days');
      } else {
        // Hide badge + badge message now
        loginButton.removeAttribute('data-badge');
      }
    }
  };

  if (header && header.dataset.processed !== 'js') {
    headerScrollAnimation();
    dialogs();
    reelReferrer();
    header.setAttribute('data-processed', 'js');
  }
})();
